import SPKEmployerCandidatesList from '$components/Positions/SPKCandidatesPositionPage/SPKEmployerCandidatesList';
import SPKCardSkeleton from '$components/SPKCardSkeleton/SPKCardSkeleton';
import ActiveValues from '$constants/ActiveValues';
import PositionInternalDto from '$types/serverTypes/positionInternalDto';
import { CandidateData } from '$types/candidates';

type SPKCandidatesPositionLayoutProps = {
  isLoadingCandidates: boolean;
  position: PositionInternalDto;
  candidates: CandidateData[];
  cps: ActiveValues;
  isLoadingSearch?: boolean;
  onNextPage?: () => void;
};
const SPKCandidatesPositionLayout = ({
  isLoadingCandidates,
  position,
  candidates,
  cps,
  isLoadingSearch = false,
  onNextPage,
}: SPKCandidatesPositionLayoutProps) => {
  return (
    <div
      className="!font-mulish w-full h-full max-h-full"
      data-testid="SPKCandidatePositionPage"
    >
      <div className="container px-4 lg:px-0 h-full max-h-full">
        {isLoadingCandidates || isLoadingSearch ? (
          <div
            className="h-full mt-2 flex flex-col gap-4"
            data-testid="loading-page1"
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <SPKCardSkeleton
                // eslint-disable-next-line react/no-array-index-key
                key={`SPKCardSkeleton_${index}`}
                height="h-56"
                className="flex-grow bg-[#EBE8DD] rounded-2xl"
              />
            ))}
          </div>
        ) : (
          <SPKEmployerCandidatesList
            activeValue={cps}
            candidates={candidates}
            position={position as PositionInternalDto}
            onNextPage={onNextPage}
          />
        )}
      </div>
    </div>
  );
};

SPKCandidatesPositionLayout.defaultProps = {
  isLoadingSearch: false,
  onNextPage: () => {},
};
export default SPKCandidatesPositionLayout;
